import { Header, Spacer, Typo } from 'components/ui-kit';
import { useFullScreen } from 'hooks';
import React, { PropsWithChildren } from 'react';
import styles from './step-card.module.scss';

type StepCardProps = PropsWithChildren<{
  title: string;
  stepNumber: string;
}>;

export const StepCard = ({
  title,
  children,
  stepNumber,
}: StepCardProps): JSX.Element => {
  const isFullScreen = useFullScreen();
  return (
    <div className={styles.step}>
      <Typo
        variant="m"
        weight="600"
        color="gray300"
        className={styles.stepNumber}
      >
        Шаг {stepNumber}
      </Typo>
      <Spacer size={8} />
      <Header level={3} weight="600" className={styles.stepTitle}>
        {title}
      </Header>
      <Spacer size={isFullScreen ? 32 : 24} />
      {children}
    </div>
  );
};
